"use strict";
var appn;
(function (appn) {
    var dataHistory;
    (function (dataHistory) {
        const _historyMaxLimit = 20;
        const _keyPrefix = 'appn-data-history-';
        function createOrEditHistory(id, dataHistoryItemObj) {
            if (!id || $.isEmptyObject(dataHistoryItemObj) || dataHistoryItemObj && (!dataHistoryItemObj.hasOwnProperty('key') || !dataHistoryItemObj.hasOwnProperty('value')))
                return;
            const appnDataHistoryParsed = appn.localStorage.getItem(_keyPrefix + id);
            if ($.isEmptyObject(appnDataHistoryParsed)) {
                appn.localStorage.setItem(_keyPrefix + id, [dataHistoryItemObj]);
                return;
            }
            if (appnDataHistoryParsed.length > _historyMaxLimit)
                appnDataHistoryParsed.pop();
            let alreadyExists = false;
            let indexToBumpToTop = -1;
            for (let i = 0; i < appnDataHistoryParsed.length; i++)
                if (appnDataHistoryParsed[i].key.trim().toLowerCase() === dataHistoryItemObj.key.trim().toLowerCase()) {
                    appnDataHistoryParsed[i].value = dataHistoryItemObj.value;
                    appnDataHistoryParsed[i].timeStamp = new Date().getTime();
                    alreadyExists = true;
                    indexToBumpToTop = i;
                    break;
                }
            if (!alreadyExists)
                appnDataHistoryParsed.unshift(dataHistoryItemObj);
            else {
                const itemToBump = appnDataHistoryParsed[indexToBumpToTop];
                appnDataHistoryParsed.splice(indexToBumpToTop, 1);
                appnDataHistoryParsed.unshift(itemToBump);
            }
            appn.localStorage.setItem(_keyPrefix + id, appnDataHistoryParsed);
        }
        dataHistory.createOrEditHistory = createOrEditHistory;
        function deleteItemObj(id, key) {
            if (!id || !key)
                return;
            const appnDataHistoryParsed = appn.localStorage.getItem(_keyPrefix + id);
            if ($.isEmptyObject(appnDataHistoryParsed)) {
                appn.localStorage.setItem(_keyPrefix + id, []);
                return;
            }
            let indexToRemove = -1;
            for (let i = 0; i < appnDataHistoryParsed.length; i++)
                if (appnDataHistoryParsed[i].key.trim().toLowerCase() === key.trim().toLowerCase()) {
                    indexToRemove = i;
                    break;
                }
            if (indexToRemove !== -1)
                appnDataHistoryParsed.splice(indexToRemove, 1);
            appn.localStorage.setItem(_keyPrefix + id, appnDataHistoryParsed);
        }
        dataHistory.deleteItemObj = deleteItemObj;
        function getDataHistory(id) {
            if (!id)
                return [];
            const appnDataHistoryParsed = appn.localStorage.getItem(_keyPrefix + id);
            if (!appnDataHistoryParsed)
                return [];
            if (!appnDataHistoryParsed || appnDataHistoryParsed.length === 0)
                return [];
            return appnDataHistoryParsed;
        }
        dataHistory.getDataHistory = getDataHistory;
    })(dataHistory = appn.dataHistory || (appn.dataHistory = {}));
})(appn || (appn = {}));
